module.exports = __webpack_public_path__ + "static/media/au-act.eec87ac0.svg";